module.exports = __webpack_public_path__ + "img/magento-migration_small.466f0884.webp";